import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { AuthTokenService } from './auth-token.service';
import { UploadEvent } from '@progress/kendo-angular-upload';
import { LoggerService } from '../shared/logger.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  constructor(
    private apiService: ApiService,
    private tokenService: AuthTokenService,
    private logger: LoggerService
  ) { }

  secureUploads(e: UploadEvent, description: string = 'File uploading') {
    this.logger.debug('secureUploads...');
    e.data = {
      description: description
    };
  };

  requestCsrfToken() {
    return this.apiService.getCsrfAsPromise();
  }

}
